<template>
  <div class="mt-3">
    <h4>{{ t('titles.donorDetails') }}</h4>
    <table class="table">
      <tbody>
        <tr v-if="donor.socialSecurityNumber">
          <td width="45%">
            {{ t('donorDetails.form.pid.label') }}
          </td>
          <td>{{ donor.socialSecurityNumber }}</td>
        </tr>
        <tr>
          <td width="45%">
            {{ t('donorDetails.form.name.label') }}
          </td>
          <td>{{ donorName }}</td>
        </tr>
        <tr v-if="donor.email">
          <td width="45%">
            {{ t('donorDetails.form.email.label') }}
          </td>
          <td>
            <v-chip variant="outlined" size="small" class="font-weight-medium">
              {{ donor.email }}
            </v-chip>
          </td>
        </tr>
        <tr v-if="donor.invoiceEmail">
          <td width="45%">
            {{ t('donorDetails.form.invoice.label') }}
          </td>
          <td>
            <v-chip variant="outlined" size="small" class="font-weight-medium">
              {{ donor.invoiceEmail }}
            </v-chip>
          </td>
        </tr>
        <tr v-if="donor.address && donor.address.address1">
          <td width="45%">
            {{ t('donorDetails.form.address.label') }}
          </td>
          <td>{{ donor.address.address1 }}</td>
        </tr>
        <tr v-if="donor.address && donor.address.postcode">
          <td width="45%">
            {{ t('donorDetails.form.postcode.label') }}
          </td>
          <td>{{ donor.address.postcode }}</td>
        </tr>
        <tr v-if="donor.address && donor.address.city">
          <td width="45%">
            {{ t('donorDetails.form.city.label') }}
          </td>
          <td>{{ donor.address.city }}</td>
        </tr>
        <tr v-if="donor.address && donor.address.country">
          <td width="45%">
            {{ t('donorDetails.form.country.label') }}
          </td>
          <td>{{ donor.address.country }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLabel } from '@/composables/useLabel';
import { Donor } from '@/interfaces/donation/donor';

export default defineComponent({
  props: {
    donor: {
      type: Object as () => Donor,
      required: true,
    },
  },
  setup(props) {
    const { t } = useLabel();
    const donorName = computed(() => {
      if (props.donor && props.donor.firstname && props.donor.firstname.length > 0) {
        return `${props.donor.firstname} ${props.donor.surname}`;
      }
      return t('donorDetails.anonymous');
    });

    return {
      t,
      donorName,
    };
  },
});
</script>

<style scoped></style>
